import React from 'react'
import url from 'front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import { capitalize, reduceRight } from 'libraries/lodash'
import Xml from 'components/shared/Xml'
import { camelCaseToSpaced } from 'helpers/string'

const LegislationResultsItemSection = ({ aol, id, isArchived, isLogged, setSignUpModalIsOpen, content, context = [] }) => {
  const getTitle = () => reduceRight(context, (a, n) => (a.title && a) || n, { title, level, number })
  const { title, level, number } = getTitle()
  const breadcrumbs = context.filter(i => !!i.title).slice(0, !title ? -1 : context.length)
  const getUrlFromId = (id) => !isLogged ? null : url(LEGISLATION, { aol, flavour: isArchived ? 'archive' : false, path: id })
  const handleOnClick = (e) => {
    if (!isLogged) {
      e.preventDefault()
      setSignUpModalIsOpen(true)
    }
  }

  if (!content || !title) {
    return null
  }

  return (
    <li className='mt7 mb3'>
      <h2 className='ma0 lh-copy f5 fw6'>
        <a
          href={getUrlFromId(id)}
          onClick={handleOnClick}
          className='black no-underline hover-cadet-blue pointer'
        >
          {number && (
            <span className='mr2'>
              {camelCaseToSpaced(level)} {number}:
            </span>
          )}
          <span><Xml render={title} /></span>
        </a>
        {isArchived && <span className='bg-dark-orchid pv2 ph4 f6 br-pill white ml4 fw5'>Archived</span>}
      </h2>
      <Breadcrumbs {...{ breadcrumbs, getUrlFromId, handleOnClick }} />
      <span className='f5 lh-copy black'>
        {isLogged ? <Xml render={content} /> : <div style={{ width: '100%', height: '1rem' }} />}
      </span>
    </li>
  )
}

const Breadcrumbs = ({ breadcrumbs, getUrlFromId, handleOnClick }) => (
  <ul className='list-reset pl0 mt2 mb3 pseudo-arrows'>
    {breadcrumbs.map((breadcrumb, index) => (
      <Breadcrumb key={index} {...{ breadcrumb, getUrlFromId, handleOnClick }} />
    ))}
  </ul>
)

const Breadcrumb = ({ breadcrumb, getUrlFromId, handleOnClick }) => {
  const { id, number, level, title } = breadcrumb
  const href = getUrlFromId(id)

  return (
    <li className='cadet-blue f7 di'>
      <a
        href={href}
        title={number && `[${capitalize(level)} ${number}]`}
        onClick={handleOnClick}
        className='cadet-blue no-underline hover-underline pointer'
      >
        {title}
      </a>
    </li>
  )
}

export default LegislationResultsItemSection
